import { required } from 'vuelidate/lib/validators';
import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';
import ChosenFundModal from '@/app/modules/fund/components/fund-choose-type/chosen-fund-modal/chosen-fund-modal.vue';
import FundDatatable from '@/app/modules/fund/components/fund-choose-type/fund-datatable/fund-datatable.vue';

export default {
  name: 'fund-choose-type',
  components: {
    ChosenFundModal,
    FundDatatable,
  },
  data: () => ({
    inputType: null,
    fundChosen: false,
    selectedFund: '',
  }),
  methods: {
    getOptions() {
      const options = [
        'Manually enter your fund information',
      ];
      const tokens = this.$store.getters['account/getActiveAccountUser'].accessTokens;
      if (tokens !== undefined) {
        if (tokens.bgl !== undefined) {
          options.push('Search using your BGL account');
        }
        if (tokens.class !== undefined) {
          options.push('Search using your CLASS account');
        }
      }
      return options;
    },
    handleContinueClick() {
      this.fundChosen = false;
      this.$emit('stepChange', 1);
    },
    handleSelectFund(fundId) {
      this.selectedFund = fundId;
      this.fundChosen = true;
    },
    handleInvalidToken() {
      this.inputType = 'Manually enter your fund information';
      EventBus.$emit('addNotification', {
        title: 'Integration - Expired Access',
        icon: 'warn',
        message: 'Unfortunately your integration access has expired, you can re-connect quickly and easily via the account management section under "Integrations"',
        isAction: true,
        action: {
          label: 'Go to Account Management',
          link: 'account-user-integrations',
        },
      });
    },
  },
  async mounted() {
    this.$store.dispatch('toggleLoading', true);
    const { accessTokens, uuid } = this.$store.getters['account/getActiveAccountUser'];
    try {
      const res = await API.post(`${ENDPOINTS.GET_INTEGRATION_REFRESH_TOKEN}`, {
        accessToken: accessTokens,
      });
      await API.post(`${ENDPOINTS.POST_ACCOUNTUSER}/${uuid}/accesstoken`, {
        token: res.data,
      });
      await this.$store.dispatch('account/refreshAccounts');
    } catch (err) {
      console.log(err);
    }
    return this.$store.dispatch('toggleLoading', false);
  },
  validations: {
    inputType: {
      required,
    },
  },
};
